import React from "react";
import RenderContent from "../../RenderContent";
import { ImagePass } from "../../Image/ImagePass";
import "./ContentAndImage.scss";
import PropTypes from "prop-types";

export const ContentAndImage = (props) => {
  const { content, image, dark_background } = props;

  return !props ? (
    <p>Content And Image Component</p>
  ) : (
    <section
      className={`
      content-and-image--component
      ${dark_background ? " content-and-image--component-dark" : ""}
      `}
    >
      <div className="content-and-image--wrapper">
        <div className="content-and-image--inner">
          <ContentPart content={content} />
          <ImagePart imageSource={image} />
        </div>
      </div>
    </section>
  );
};

ContentAndImage.propTypes = {
  content: PropTypes.string,
  // image: PropTypes.object,
  darkBackground: PropTypes.bool,
};

ContentAndImage.defaultProps = {
  content: "<p>Content for the ContentAndImage Component</p>",
  image: {
    sourceUrl: "",
  },
  darkBackground: false,
};

const ContentPart = ({ content }) => {
  return (
    <div className="content-and-image--contentpart">
      <div className="content-and-image--contentpart--wrapper">
        {/* <div
          dangerouslySetInnerHTML={{ __html: content }}
          className="content-and-image--contentpart--content"
        /> */}
        <RenderContent content={content} />
      </div>
    </div>
  );
};

const ImagePart = ({ imageSource }) => {
  return (
    <div className="content-and-image--imagepart">
      {imageSource && (
        <ImagePass
          src={imageSource}
          position={`relative`}
          className="background"
        />
      )}
    </div>
  );
};
